export function validateStepAccess(
  store,
  requiredType,
  requiredSteps = [],
  router,
  fallback = '/'
) {
  const isWrongType = store.typeClient !== requiredType
  const steps = Array.isArray(requiredSteps) ? requiredSteps : [requiredSteps]
  const isMissingStep = steps.some((step) => !store.isStepCompleted(step))

  if (isWrongType || isMissingStep) {
    router.replace(fallback)
  }
}
